import { Outlet, createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { App, ConfigProvider } from 'antd';
import antConfig from '@/theme/antdConfig.ts';
import { ApolloProvider } from '@apollo/client';
import client from '@/api';
import '@flemme-template/components/output.css';
import { OnboardingProvider } from '@/context/OnboarrdingContext';
import * as Sentry from '@sentry/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Layout } from '@/components/Layout';

import frFR from 'antd/locale/fr_FR';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';

Sentry.init({
  dsn: 'https://c05a61661abe8c9e411130cc75d01924@o1063428.ingest.us.sentry.io/4509312311099397',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,

  integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],

  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/app-flemme.bedones.com/],
});

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        title: 'Flemme',
        description: 'Generate resume and cover letter for a job in minutes for free',
      },
    ],
  }),
  component: RootComponent,
});

function RootComponent() {
  const { i18n } = useTranslation();

  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_APP_GOOGLE_CLIENT_ID}>
      <ApolloProvider client={client}>
        <ConfigProvider {...antConfig()} locale={i18n.resolvedLanguage === 'fr' ? frFR : enUS}>
          <App>
            <OnboardingProvider>
              <Layout>
                <Outlet />
                <TanStackRouterDevtools />
              </Layout>
            </OnboardingProvider>
          </App>
        </ConfigProvider>
      </ApolloProvider>
    </GoogleOAuthProvider>
  );
}
